import {
  Button,
  ButtonColor,
  ButtonSize,
  Combobox,
  Option,
  TextInput,
} from '@code/innovance-react-ui-kit';
import React, { FC } from 'react';
import { Controller, FieldError, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ButtonRow, FormElement, FormRow, ResetButton } from 'src/front/components/FormStyles';

export interface SearchFormData {
  accountNumber?: string;
  accountState?: Option;
  accountType?: Option;
  branch?: Option;
  currency?: Option;
  accountMask?: Option;
  channel?: Option;
  accountManager?: string;
  // openingDateFrom?: Date | null;
  // openingDateTo?: Date | null;
  // closingDateFrom?: Date | null;
  // closingDateTo?: Date | null;
}

export const searchDefaultValues = {
  accountNumber: '',
  accountState: undefined,
  accountType: undefined,
  branch: undefined,
  currency: undefined,
  accountMask: undefined,
  channel: undefined,
  accountManager: '',
  // openingDateFrom: null,
  // openingDateTo: null,
  // closingDateFrom: null,
  // closingDateTo: null,
};

interface Props {
  onSubmit: (formData: SearchFormData) => void;
  formValues?: SearchFormData;
  disabled?: boolean;
  accountTypes: Array<Option>;
  branches: Array<Option>;
  currencies: Array<Option>;
  accountMasks: Array<Option>;
}

const AccountSearchForm: FC<Props> = ({
  onSubmit,
  formValues,
  accountTypes,
  branches,
  currencies,
  accountMasks,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const { errors, handleSubmit, control, reset, formState } = useForm<SearchFormData>({
    defaultValues: { ...searchDefaultValues, ...formValues },
  });

  const onReset = (): void => reset();

  const accountStates = [
    { value: '0', label: 'Закрыто' },
    { value: '1', label: 'Открыто' },
  ];
  const channels = [
    { value: '001', label: 'ОТДЕЛЕНИЕ' },
    { value: '007', label: 'Банкомат' },
    { value: '060', label: 'FrontEnd' },
    { value: '072', label: 'CEBconnect' },
    { value: '600', label: 'Мобильный Банк' },
    { value: '604', label: 'NEWIB' },
    { value: '788', label: 'ФИНУСЛУГИ' },
  ];
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormRow>
        <FormElement>
          <Controller
            control={control}
            name="accountNumber"
            render={({ onChange, value }) => (
              <TextInput
                disabled={disabled}
                errorMessage={t(errors?.accountNumber?.message as string)}
                label={t('allAccountObservation_accountSearchForm_accountNumber_label')}
                name="accountNumber"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </FormElement>
      </FormRow>
      <FormRow>
        <FormElement>
          <Controller
            control={control}
            name="accountState"
            render={({ onChange, value }) => (
              <Combobox
                errorMessage={t((errors?.accountState as FieldError)?.message as string)}
                items={accountStates}
                label={t('allAccountObservation_accountSearchForm_accountState_label')}
                name="accountState"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </FormElement>
        <FormElement>
          <Controller
            control={control}
            name="accountType"
            render={({ onChange, value }) => (
              <Combobox
                errorMessage={t((errors?.accountType as FieldError)?.message as string)}
                items={accountTypes}
                label={t('allAccountObservation_accountSearchForm_accountType_label')}
                name="accountType"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </FormElement>
      </FormRow>
      <FormRow>
        <FormElement>
          <Controller
            control={control}
            name="currency"
            render={({ onChange, value }) => (
              <Combobox
                errorMessage={t((errors?.currency as FieldError)?.message as string)}
                items={currencies}
                label={t('allAccountObservation_accountSearchForm_currency_label')}
                name="currency"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </FormElement>
        <FormElement>
          <Controller
            control={control}
            name="accountMask"
            render={({ onChange, value }) => (
              <Combobox
                errorMessage={t((errors?.accountMask as FieldError)?.message as string)}
                items={accountMasks}
                label={t('allAccountObservation_accountSearchForm_accountMask_label')}
                name="accountMask"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </FormElement>
      </FormRow>
      <FormRow>
        <FormElement>
          <Controller
            control={control}
            name="channel"
            render={({ onChange, value }) => (
              <Combobox
                errorMessage={t((errors?.channel as FieldError)?.message as string)}
                items={channels}
                label={t('allAccountObservation_accountSearchForm_channel_label')}
                name="channel"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </FormElement>
        <FormElement>
          <Controller
            control={control}
            name="branch"
            render={({ onChange, value }) => (
              <Combobox
                errorMessage={t((errors?.branch as FieldError)?.message as string)}
                items={branches}
                label={t('allAccountObservation_accountSearchForm_branch_label')}
                name="branch"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </FormElement>
      </FormRow>
      <ButtonRow>
        {formState.isSubmitSuccessful ? (
          <ResetButton
            color={ButtonColor.Secondary}
            disabled={disabled}
            onClick={onReset}
            size={ButtonSize.Medium}
            text={t('general_components_reset_button')}
            type="reset"
          />
        ) : null}
        <Button
          color={ButtonColor.Primary}
          disabled={formState.isSubmitting || disabled}
          size={ButtonSize.Medium}
          text={t('general_components_search_button')}
          type="submit"
        />
      </ButtonRow>
    </form>
  );
};

export default AccountSearchForm;
